import React from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import { RELATED_MAP } from '../../data/relatedArticles';
import postsData from '../../data/postsData';

/**
 * Renders 3 editorially-curated related articles for a given blog post.
 * @param {{ slug: string }} props — the current article's route slug
 */
const RelatedArticles = ({ slug }) => {
  const { lng } = useParams();
  const relatedSlugs = RELATED_MAP[slug];
  if (!relatedSlugs?.length) return null;

  const articles = relatedSlugs
    .map(s => postsData.find(p => p.path?.endsWith(s)))
    .filter(Boolean);

  if (!articles.length) return null;

  const handleCrossClick = (targetPath) => {
    if (window.plausible) window.plausible('Cross Link Click', { props: { from: slug, to: targetPath } });
  };

  return (
    <Box sx={{ mt: 6, mb: 4 }}>
      <Typography variant="h4" sx={{ color: '#1A1A1A', mb: 3 }}>
        También te puede interesar
      </Typography>
      <Grid container spacing={3}>
        {articles.map((p) => {
          const targetPath = p.path || `/blog/${p.slug}`;
          return (
          <Grid item xs={12} sm={4} key={p.id}>
            <Card sx={{
              borderRadius: '10px',
              overflow: 'hidden',
              height: '100%',
              border: '1px solid #EEF0F3',
              boxShadow: 'none',
              transition: 'box-shadow 0.3s',
              '&:hover': { boxShadow: '0 6px 20px rgba(0,0,0,0.08)' },
            }}>
              <CardActionArea component={RouterLink} to={`/${lng}${targetPath}`} onClick={() => handleCrossClick(targetPath)}>
                <CardMedia
                  component="img"
                  image={p.image}
                  alt={p.title}
                  loading="lazy"
                  sx={{ width: '100%', objectFit: 'cover', aspectRatio: '16/9' }}
                />
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1A1A1A', lineHeight: 1.3 }}>
                    {p.title}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#5F6B7A', mt: 1, display: 'block' }}>
                    {p.readTime} min de lectura
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default RelatedArticles;
